import React from 'react';

import { Box, Button, Typography } from '@mui/material';

import { colors } from '../../utils/colors';

interface SectionButtonProps {
  icon: React.ElementType;
  name: string;
  isActive: boolean;
  onClick: () => void;
  rightIcon?: React.ReactNode;
  isLocked?: boolean;
}

const SectionButton: React.FC<SectionButtonProps> = ({
  icon,
  name,
  isActive,
  onClick,
  rightIcon,
}) => {
  return (
    <Button
      fullWidth
      onClick={onClick}
      sx={{
        justifyContent: 'flex-start',
        padding: 2,
        backgroundColor: 'transparent',
        color: isActive ? 'primary.main' : 'inherit',
        '&:hover': {
          color: colors.accent,
          backgroundColor: isActive ? 'transparent' : 'primary.light',
          cursor: isActive ? 'default' : 'pointer',
        },
        '&:active': {
          color: colors.accent,
          backgroundColor: isActive ? 'transparent' : 'primary.light',
        },
      }}
    >
      <Box display="flex" alignItems="center" width="100%">
        {React.createElement(icon, {
          sx: {
            color: isActive ? 'primary' : 'inherit',
            mr: 1,
          },
        })}
        <Typography
          sx={{
            mr: 2,
            fontWeight: isActive ? '700' : '400',
          }}
          textAlign={'left'}
        >
          {name}
        </Typography>
        {rightIcon && <Box ml={'auto'}>{rightIcon}</Box>}
      </Box>
    </Button>
  );
};

export default SectionButton;
